export const REPORTS_SKIP_TO = 'report-input-main';
